const volvoCareersLink = 'https://www.volvocars.com/intl/v/careers/highlights';
const volvoSupportPrivacyLink =
  'https://www.volvocars.com/intl/legal?path=privacy';

export { volvoCareersLink, volvoSupportPrivacyLink };
